import React from 'react';
import { Box, Heading, Text,  HStack, Image, SimpleGrid, Flex } from '@chakra-ui/react';
import { FaHome, FaClipboardList, FaWallet, FaChartLine, FaBell, FaExchangeAlt, FaCog, FaShoppingBasket } from 'react-icons/fa';
import { Link } from 'react-router-dom';

const menuItems = [
  {
    itemName: 'Item 1',
    price: 10,
    description: 'Description for Item 1',
    image: 'item1.jpg',
    quantityInStock: 5,
  },
  {
    itemName: 'Item 2',
    price: 15,
    description: 'Description for Item 2',
    image: 'item2.jpg',
    quantityInStock: 10,
  },
  // Add more menu items here
];

const RestaurantMenu = () => {
  return (
    <Box bg="gray.50" p={8}>
      <Box bg="white" p={4} borderRadius="md" mb={4}>
        <Heading color="blue.200">Menu</Heading>
      </Box>
      
      <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacing={4}>
        {menuItems.map((menuItem, index) => (
          <Box
            key={index}
            bg="white"
            p={4}
            borderRadius="xl" // Border radius of 45
            boxShadow="md"
            transition="transform 0.2s ease-in-out" // Transition for hover effect
            _hover={{ transform: 'translateY(-5px)' }} // Hover effect
          >
            <Image src={menuItem.image} alt={menuItem.itemName} h="150px" objectFit="cover" mb={2} />
            <Heading color="blue.200" fontSize="lg" fontWeight="bold" mb={2}>
              {menuItem.itemName}
            </Heading>
            <Text color="blue.200" fontWeight="medium" mb={2}>
              {menuItem.description}
            </Text>
            <HStack justifyContent="space-between">
              <Text color="blue.200" fontWeight="medium">
                ${menuItem.price.toFixed(2)}
              </Text>
              <Text color="blue.200" fontWeight="medium">
                In Stock: {menuItem.quantityInStock}
              </Text>
            </HStack>
          </Box>
        ))}
      </SimpleGrid>
            {/* Bottom Navigation for Mobile */}
            <Flex
          bg="blue.200"
          p={2}
          mt={4}
          align="center"
          justify="space-between"
          position="fixed"
          bottom={0}
          mx="auto"
          width="95%"
          display={{ base: 'flex', md: 'none' }} // Hide on larger screens
        >
            <Box textAlign="center" flex="1" p={2}>
              <Link to="restaurant">
                  <Flex alignItems="center" flexDirection="column">
                  <FaHome />
                  <Text color="white" fontSize="xs" mt={1}>
                      Home
                  </Text>
                  </Flex>
              </Link>
            </Box>
            <Box textAlign="center" flex="1" p={2}>
              <Link to="/restaurant-orders">
                  <Flex alignItems="center" flexDirection="column">
                  <FaClipboardList />
                  <Text color="white" fontSize="xs" mt={1}>
                      Orders
                  </Text>
                  </Flex>
              </Link>
            </Box>
            <Box textAlign="center" flex="1" p={2}>
              <Link to="/restaurant-market-place">
                  <Flex alignItems="center" flexDirection="column">
                  <FaShoppingBasket />
                  <Text color="white" fontSize="xs" mt={1}>
                      Market
                  </Text>
                  </Flex>
              </Link>
            </Box>
            <Box textAlign="center" flex="1" p={2}>
            <Link to="/restaurant-analytics">
                <Flex alignItems="center" flexDirection="column">
                <FaChartLine />
                <Text color="white" fontSize="xs" mt={1}>
                    Analytics
                </Text>
                </Flex>
            </Link>
            </Box>
            <Box textAlign="center" flex="1" p={2}>
              <Link to="/restaurant-wallet">
                  <Flex alignItems="center" flexDirection="column">
                  <FaWallet />
                  <Text color="white" fontSize="xs" mt={1}>
                      Wallet
                  </Text>
                  </Flex>
              </Link>
            </Box>
            <Box textAlign="center" flex="1" p={2}>
              <Link to="/restaurant-trades">
                  <Flex alignItems="center" flexDirection="column">
                  <FaExchangeAlt />
                  <Text color="white" fontSize="xs" mt={1}>
                      Trades
                  </Text>
                  </Flex>
              </Link>
            </Box>
            <Box textAlign="center" flex="1" p={2}>
              <Link to="/restaurant-notifications">
                  <Flex alignItems="center" flexDirection="column">
                  <FaBell />
                  <Text color="white" fontSize="xs" mt={1}>
                      Notifications
                  </Text>
                  </Flex>
              </Link>
            </Box>
            <Box textAlign="center" flex="1" p={2}>
              <Link to="/restaurant-settings">
                  <Flex alignItems="center" flexDirection="column">
                  <FaCog />
                  <Text color="white" fontSize="xs" mt={1}>
                      Settings
                  </Text>
                  </Flex>
              </Link>
            </Box>   
        </Flex>
        
    </Box>
  );
};

export default RestaurantMenu;
